const EditLedger = require('./EditLedger').default;

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.editLedgerNew', deps)
  .directive('editLedger', reactDirective => reactDirective(EditLedger));
